/**
 * The one-shot join card (3039; `design/GT Mobile Round.dc.html`, `rCardOn`):
 * fires above the tab bar when someone starts a round you are not in.
 * NOT TONIGHT is sticky for that round; the chip keeps pulsing.
 */

import { Avatar } from '../components/Avatar.tsx';
import { PixelButton } from '../components/PixelButton.tsx';
import { useQd } from '../store/index.ts';
import { roundChipVM } from '../store/selectors.round.ts';

const MONO = 'var(--gt-font-mono)';

export default function RoundJoinCard(): JSX.Element | null {
  const s = useQd();
  const v = roundChipVM(s);
  if (!v.rCardOn) return null;
  return (
    <div style={{ position: 'fixed', left: '50%', transform: 'translateX(-50%)', bottom: 96, zIndex: 70, width: '100%', maxWidth: 402, background: 'var(--gt-card)', border: '1px solid var(--acc)', boxShadow: 'var(--gt-shadow-toast)', animation: 'gt-toast .18s ease-out', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 15px', borderBottom: '1px solid var(--gt-line)' }}>
        <Avatar size={26} fs={8} ini={v.cardWhoIni} bg={v.cardWhoBg} hasAv={v.cardWhoHasAv} avBg={v.cardWhoAv} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, minWidth: 0, flex: 1 }}>
          <span style={{ fontFamily: 'var(--gt-font-pixel)', fontSize: 8, color: 'var(--acc)', transform: 'translateY(0.13em)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {v.rCardWho} STARTED GAME NIGHT
          </span>
          <span style={{ fontFamily: MONO, fontSize: 9, letterSpacing: '.06em', color: 'var(--gt-muted)', whiteSpace: 'nowrap' }}>{v.rCardSub}</span>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 15px' }}>
        <div onClick={() => s.rDismiss()} style={{ display: 'flex', alignItems: 'center', height: 44, fontFamily: MONO, fontSize: '9.5px', letterSpacing: '.06em', color: 'var(--gt-muted)', cursor: 'pointer', whiteSpace: 'nowrap' }}>
          NOT TONIGHT
        </div>
        <div style={{ flex: 1 }} />
        <PixelButton label="JOIN ▸" fs={10} pad="15px 20px" nowrap fit lh="1" busy={s.rBusy} onClick={() => void s.rJoin()} />
      </div>
    </div>
  );
}
